const maxDepth=3;
let nodeId=0;
function setupMenu(menu){
  if(menu.dataset.tsReady==='1')return;
  const template=menu.querySelector('template[data-ts-catalog]');
  if(!template)return;
  const all=[...template.content.querySelectorAll('a[data-ts-id]')].map(a=>({
    id:a.dataset.tsId||'',parentId:a.dataset.tsParent||'',title:a.dataset.tsTitle||'',url:a.getAttribute('href')||'',hasProducts:a.dataset.tsHasProducts==='1'
  })).filter(c=>c.id&&c.title&&c.url);
  const byId=new Map(all.map(c=>[c.id,c]));
  const children=new Map();
  for(const c of all){
    if(!c.parentId||c.parentId===c.id)continue;
    if(!children.has(c.parentId))children.set(c.parentId,[]);
    children.get(c.parentId).push(c);
  }
  // Keep a category when it has storefront-visible products or a visible descendant.
  // The current navigation supports three nested levels; don't keep a parent
  // solely because of products in descendants deeper than the rendered menu.
  function visible(item,depth,path){
    if(item.hasProducts)return true;
    if(depth>=maxDepth||!item.id)return false;
    const nextPath=new Set(path);nextPath.add(item.id);
    return (children.get(item.id)||[]).some(c=>!nextPath.has(c.id)&&visible(c,depth+1,nextPath));
  }
  function node(item,depth,path){
    const li=document.createElement('li');li.className='ts-collection-mega__entry';li.dataset.tsDepth=depth;
    const line=document.createElement('div');line.className='ts-collection-mega__row';
    const link=document.createElement(item.hasProducts?'a':'span');link.className='ts-collection-mega__link';
    if(item.hasProducts)link.href=item.url;
    link.textContent=item.title;line.append(link);li.append(line);
    if(depth<maxDepth&&item.id){
      const nextPath=new Set(path);nextPath.add(item.id);
      const next=(children.get(item.id)||[]).filter(c=>!nextPath.has(c.id)&&visible(c,depth+1,nextPath));
      if(next.length){
        const sub=document.createElement('ul');sub.className='ts-collection-mega__sublist list-unstyled';
        sub.id='ts-category-sub-'+(++nodeId);sub.setAttribute('role','list');
        const btn=document.createElement('button');btn.type='button';btn.className='ts-collection-mega__toggle';
        btn.textContent='⌄';btn.setAttribute('aria-expanded','false');
        btn.setAttribute('aria-label','Apri sottocategorie di '+item.title);
        btn.setAttribute('aria-controls',sub.id);
        btn.addEventListener('click',e=>{
          e.preventDefault();const open=li.classList.toggle('ts-cat-open');
          btn.setAttribute('aria-expanded',String(open));
          btn.setAttribute('aria-label',(open?'Chiudi':'Apri')+' sottocategorie di '+item.title);
        });
        li.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')btn.setAttribute('aria-expanded','true')});
        li.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'&&!li.classList.contains('ts-cat-open'))btn.setAttribute('aria-expanded','false')});
        for(const c of next)sub.append(node(c,depth+1,nextPath));
        line.append(btn);li.append(sub);
      }
    }
    return li;
  }
  for(const root of menu.querySelectorAll('[data-ts-root]')){
    const ul=root.querySelector('[data-ts-root-list]');if(!ul)continue;
    const rootId=root.dataset.tsId||'';const selected=new Map();
    for(const old of ul.querySelectorAll(':scope > [data-ts-legacy]')){
      const a=old.querySelector('a[href]');if(!a)continue;
      const id=old.dataset.tsId||'';const entry=byId.get(id);
      if(entry?.parentId&&entry.parentId!==rootId)continue;
      const item=entry;
      if(item?.url&&visible(item,1,new Set([rootId])))selected.set(id||item.url,item);
    }
    for(const c of children.get(rootId)||[]){
      if(visible(c,1,new Set([rootId])))selected.set(c.id,c);
    }
    const fragment=document.createDocumentFragment();
    for(const c of selected.values())fragment.append(node(c,1,new Set([rootId])));
    ul.replaceChildren(fragment);
    root.hidden=root.dataset.tsHasProducts!=='1'&&selected.size===0;
  }
  menu.dataset.tsReady='1';
}
function initMenus(){document.querySelectorAll('[data-ts-collection-mega]:not([data-ts-ready="1"])').forEach(setupMenu)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initMenus,{once:true});else initMenus();
document.addEventListener('shopify:section:load',initMenus);
const header=document.querySelector('#header-group');
if(header){
  let queued=false;
  new MutationObserver(()=>{
    if(queued)return;queued=true;
    queueMicrotask(()=>{queued=false;initMenus()});
  }).observe(header,{childList:true,subtree:true});
}
